import { Pipe, PipeTransform } from '@angular/core';
import { CommonHelper } from 'src/app/helpers/common';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  constructor(private commonHelper: CommonHelper) { }

  transform(value: any, args?: any): any {
    return this.commonHelper.getTranslation(value);
  }

}